import {
  PACKAGE_LIST_LOADING,
  GET_PACKAGE_LIST,
  GET_PACKAGE_LIST_ERROR,
  GET_PACKAGE_BY_ID_LOADING,
  GET_PACKAGE_BY_ID_SUCCESS,
  GET_PACKAGE_BY_ID_ERROR,
  DELETEING_PACKAGE,
  DELETE_PACKAGE,
  DELETE_PACKAGE_ERROR,
  DELETED_PACKAGE_LIST_LOADING,
  GET_DELETED_PACKAGE_LIST,
  GET_DELETED_PACKAGE_LIST_ERROR,
  RESTORE_PACKAGE_LIST_LOADING,
  RESTORE_PACKAGE_LIST,
  RESTORE_PACKAGE_LIST_ERROR,   
  PERMA_DELETE_PACKAGE,
  PERMA_DELETE_PACKAGE_ERROR,
  PERMA_DELETEING_PACKAGE,
  
} from "./types";
import axios from "axios";
import { BASE_URL } from "../urls";
import { message } from "antd";

export const getList = (tokenData) => async (dispatch) => {
  dispatch({
    type: PACKAGE_LIST_LOADING,
  });
  await axios
    .get(`${BASE_URL}api/v1/admin/travel/package/active`, {
      headers: {
        'Authorization': `${tokenData.token_type} ${tokenData.access_token}`
      }
    })
    .then(function (response) {
      dispatch({
        type: GET_PACKAGE_LIST,
        payload: response,
      });
    })
    .catch(function (error) {
      dispatch({
        type: GET_PACKAGE_LIST_ERROR,
        payload: error.response,
      });
    });
};

export const getEntityById = (tokenData, id) => async (dispatch) => {
  dispatch({
    type: GET_PACKAGE_BY_ID_LOADING,
  });
  await axios
    .get(`${BASE_URL}api/v1/admin/travel/package/active/${id}`, {
      headers: {
        'Authorization': `${tokenData.token_type} ${tokenData.access_token}`
      }
    })
    .then(function (response) {
      dispatch({
        type: GET_PACKAGE_BY_ID_SUCCESS,
        payload: response,
      });
    })
    .catch(function (error) {
      dispatch({
        type: GET_PACKAGE_BY_ID_ERROR,
        payload: error.response,
      });
    });
};

export const getDeletedList = (tokenData) => async (dispatch) => {
  dispatch({
    type: DELETED_PACKAGE_LIST_LOADING,
  });
  await axios
    .get(`${BASE_URL}api/v1/admin/travel/package/deleted`, {
      headers: {
        'Authorization': `${tokenData.token_type} ${tokenData.access_token}`
      }
    })
    .then(function (response) {
      dispatch({
        type: GET_DELETED_PACKAGE_LIST,
        payload: response,
      });
    })
    .catch(function (error) {
      dispatch({
        type: GET_DELETED_PACKAGE_LIST_ERROR,
        payload: error.response,
      });
    });
};

export const deleteEntityById = (idList) => async (dispatch) => {
  dispatch({
    type: DELETEING_PACKAGE,
  });
  let bulk = {bulk: idList}
  await axios
    .post(`${BASE_URL}api/v1/admin/travel/package/bulk/delete`, bulk, {
      headers: {
        'Authorization': `${localStorage.token_type} ${localStorage.access_token}`
      }
    })
    .then(function (response) {
      dispatch({
        type: DELETE_PACKAGE,
        payload: response,
      })      
      message.success(response.data.message);
    })
    .catch(function (error) {
      dispatch({
        type: DELETE_PACKAGE_ERROR,
        payload: error.response,
      })      
      message.error(error.response.data.message);
    });
};

export const permanentDeleteEntity = (idList) => async (dispatch) => {
  dispatch({
    type: PERMA_DELETEING_PACKAGE,
  });
  let bulk = {bulk: idList}
  await axios
    .post(`${BASE_URL}api/v1/admin/travel/package/bulk/perma-delete`, bulk, {
      headers: {
        'Authorization': `${localStorage.token_type} ${localStorage.access_token}`
      }
    })
    .then(function (response) {
      dispatch({
        type: PERMA_DELETE_PACKAGE,
        payload: response,
      })      
      message.success(response.data.message);
    })
    .catch(function (error) {
      dispatch({
        type: PERMA_DELETE_PACKAGE_ERROR,
        payload: error.response,
      })      
      message.error(error.response.data.message);
    });
};

export const restoretDeleteEntity = (idList, history) => async (dispatch) => {
  dispatch({
    type: RESTORE_PACKAGE_LIST_LOADING,
  });
  let bulk = {bulk: idList}
  await axios
    .post(`${BASE_URL}api/v1/admin/travel/package/bulk/restore`, bulk, {
      headers: {
        'Authorization': `${localStorage.token_type} ${localStorage.access_token}`
      }
    })
    .then(function (response) {
      dispatch({
        type: RESTORE_PACKAGE_LIST,
        payload: response,
      })
      message.success(response.data.message);
        history.push("/packages")        
    })
    .catch(function (error) {
      dispatch({
        type: RESTORE_PACKAGE_LIST_ERROR,
        payload: error.response,
      })   
      message.error(error.response.data.message);
    });
};



